import { Service } from '../types';

export const services: Service[] = [
  {
    id: 'concept',
    number: '01',
    title: 'Concept & Creative',
    description:
      'Narrative, art direction and stage design that turn an idea into a world your guests step inside.',
    capabilities: ['Creative strategy', 'Art direction', 'Stage & set design', 'Brand storytelling'],
  },
  {
    id: 'production',
    number: '02',
    title: 'Production',
    description:
      'Lighting, sound, AV and live broadcast handled by a touring-grade crew that has already done it at scale.',
    capabilities: ['Lighting design', 'Audio engineering', 'LED & projection', 'Live broadcast'],
  },
  {
    id: 'talent',
    number: '03',
    title: 'Talent & Hospitality',
    description:
      'Headline artists, hosts, dancers and crew — booked, briefed and looked after from arrival to encore.',
    capabilities: ['Artist booking', 'Host & MC curation', 'Backstage hospitality', 'Tour logistics'],
  },
  {
    id: 'experience',
    number: '04',
    title: 'Guest Experience',
    description:
      'Every touchpoint — from invitation to after-party — choreographed so the audience never sees the seams.',
    capabilities: ['Invitations & RSVP', 'Hospitality desks', 'Run-of-show', 'After-party design'],
  },
];
